import { render, staticRenderFns } from "./banknotes.vue?vue&type=template&id=b74f734a&"
import script from "./banknotes.vue?vue&type=script&lang=js&"
export * from "./banknotes.vue?vue&type=script&lang=js&"
import style0 from "./banknotes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports